import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import programReducer from '../program/reducer';
import contentReducer from '../content/reducer';
import onboarderReducer from '../onboarder/reducer';
import htmlReducer from '../html/reducer';

export default combineReducers({
  routing: routerReducer,
  program: programReducer,
  content: contentReducer,
  onboarder: onboarderReducer,
  html: htmlReducer
});



// WEBPACK FOOTER //
// ./src/containers/app/reducer.js